{
  "popup_modal": {
    "title": {
      "validate": "Validate",
      "warning": "Warning",
      "alert": "Alert"
    },
    "validate": "Validate",
    "cancel": "Cancel"
  },
  "breadcrumbs": {
    "contract_management": {
      "management": "Management",
      "signature": "Signature",
      "deposit_management": "Deposit management"
    }
  }
}
